import NominalLedger from "./NominalLedger";

const NominalLedgerConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/nominal-ledger',
            element: <NominalLedger />,
        },
    ],
}

export default NominalLedgerConfig;